var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1094 0.890819C16.6992 0.480662 16.1428 0.250244 15.5627 0.250244C14.9826 0.250244 14.4263 0.480662 14.016 0.890819L13.0519 1.85499L16.1452 4.94832L17.1094 3.98415C17.5195 3.57393 17.75 3.01758 17.75 2.43749C17.75 1.85739 17.5195 1.30104 17.1094 0.890819ZM15.261 5.83249L12.1677 2.73915L2.04271 12.8642C1.52842 13.3782 1.15036 14.0123 0.942712 14.7092L0.276046 16.9467C0.243859 17.0546 0.241458 17.1693 0.269098 17.2785C0.296737 17.3877 0.353389 17.4875 0.433058 17.5671C0.512728 17.6468 0.612451 17.7035 0.721678 17.7311C0.830905 17.7587 0.945571 17.7563 1.05355 17.7242L3.29105 17.0575C3.9879 16.8498 4.62201 16.4718 5.13605 15.9575L15.261 5.83249Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/modify.5e4f2c12ccf5768dbbd7431059ec8d0f.svg";
export { ForwardRef as ReactComponent };